import { BaseQueryApi, BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query";
import { RTKErrorType } from "../../types";
import { LoginErrorResponse } from "../../types/api-response";

type BaseQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>

export function baseQueryWithAuthCheck(baseQuery: BaseQuery) {
    return async (args: any, api: BaseQueryApi, extraOptions: any) => {
        let result = await baseQuery(args, api, extraOptions);
        // console.log("baseQueryOverride", result);

        if (result.error) {
            if (result.error.status === 401) {
                const url = window.location.href;
                const loginUrl = (result.error as RTKErrorType<LoginErrorResponse>)?.data?.log_in_url;
                const redirectUrl = loginUrl + "?src=" + encodeURIComponent(url);               
                window.location.href = redirectUrl; // redirect login page
            }
        }

        return result;
    }
}